import Vue from 'vue'

// axios
import axios from 'axios'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  // baseURL: 'https://some-domain.com/api/',
  // timeout: 1000,
  headers: {"Access-Control-Allow-Origin":"*"}
})

Vue.prototype.$http = axiosIns
// Vue.prototype.rootHost = "http://192.168.1.226:2052";     
// Vue.prototype.host = "http://192.168.1.226:2052";


export default axiosIns



// WEBPACK FOOTER //
// ./src/libs/axios.js